export default __webpack_public_path__ + "static/media/chris.933bb611.png";